{
  "phone-number-input": {
    "text": {
      "country-code": "Kód země",
      "country-code-invalid": "Neplatné",
      "country-code-required": "Povinné",
      "phone-nr": "Telefonní číslo",
      "phone-nr-invalid": "Číslo mobilního telefonu je neplatné",
      "phone-nr-required": "Vyžaduje se číslo mobilního telefonu"
    }
  }
}
